import Copy from "components/copy";
import FormButtons from "components/forms/buttons";
import { CancelButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import Indicator from "components/indicator";
import Modal from "components/layout/modal";
import ValuePair from "components/valuepair";
import dayjs from "dayjs";
import { timestamp } from "lib/date";
import { isLocalhost } from "lib/env";
import { getPublicUrl } from "lib/url";
import { ListInvitation } from "models/list-invitation";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useOrganization } from "stores/hooks/organization";

interface LinkModalProps {
  invitation: ListInvitation;
  onClose: () => Promise<void>;
}
const LinkModal: FunctionComponent<LinkModalProps> = ({
  invitation,
  onClose,
}) => {
  const { uuid, expires_at } = invitation;

  const methods = useForm();

  const organization = useOrganization();
  if (!organization) {
    return null;
  }

  const url = getPublicUrl(organization.tenant, `/user/invitation/${uuid}`);
  const expired = dayjs(expires_at).isBefore(dayjs());

  // a debug url for the localhost
  const localhostUrl = `http://localhost:4001/user/invitation/${uuid}/login?tenant=${organization.tenant}`;

  return (
    <Modal title="Kopioi kutsulinkki">
      <Form methods={methods} onSubmit={async () => {}}>
        <Grid>
          <Row>
            <Col>
              <ValuePair label="Osoite">
                {url} <Copy value={url} />
              </ValuePair>
            </Col>
          </Row>
          {isLocalhost() && (
            <Row>
              <Col>
                <ValuePair label="Localhost shortcut">
                  {localhostUrl} <Copy value={localhostUrl} />
                </ValuePair>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <ValuePair label="Voimassa">
                <Indicator type={expired ? "negative" : "positive"}>
                  {timestamp(invitation.expires_at)}
                </Indicator>
              </ValuePair>
            </Col>
          </Row>
          <FormButtons buttons={[{ ...CancelButton, onClick: onClose }]} />
        </Grid>
      </Form>
    </Modal>
  );
};

export default LinkModal;
